/**
 * Warm-up obrázků v navigaci.
 *
 * Dlaždice mega menu a drawer (snippets/tb-nav-tile.liquid, tb-nav-megamenu-card.liquid)
 * mají loading="lazy", protože jsou na každé stránce webu dvakrát a při načtení
 * je nikdo nevidí. S eager kradly linku hlavnímu obrázku produktu.
 *
 * Lazy ale znamená, že skrytý obrázek se nezačne stahovat vůbec, takže by první
 * otevření menu čekalo na síť. Tenhle skript ho proto dotáhne, jakmile je
 * stránka načtená a prohlížeč nic nedělá. Když uživatel stihne sáhnout na menu
 * dřív, spustí se warm-up okamžitě.
 *
 * Stejný kompromis jako preloadSlides() v media-gallery.js u galerie produktu.
 */
(function () {
  var SELECTOR = [
    '.menu-item-submenu-list img[loading="lazy"]',
    '.megamenu-card-container img[loading="lazy"]',
    '.menu-drawer img[loading="lazy"]',
    '.header__inline-menu img[loading="lazy"]',
  ].join(', ');
  var done = false;

  function warmUp() {
    if (done) return;
    done = true;
    document.querySelectorAll(SELECTOR).forEach(function (img) {
      /* Přepnutí lazy → eager rozjede stahování i u skrytého obrázku. */
      img.setAttribute('loading', 'eager');
      img.setAttribute('fetchpriority', 'low');
    });
  }

  /* Kdo první: nečinnost po načtení stránky, nebo dotyk uživatele na navigaci. */
  function scheduleIdle() {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(warmUp, { timeout: 3000 });
    } else {
      window.setTimeout(warmUp, 1500);
    }
  }

  if (document.readyState === 'complete') {
    scheduleIdle();
  } else {
    window.addEventListener('load', scheduleIdle, { once: true });
  }

  ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.closest && event.target.closest('header, .header, .menu-drawer, tb-header-nav')) {
        warmUp();
      }
    }, { capture: true, passive: true });
  });
})();
